var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ams-info", attrs: { id: "tab-ams" } },
    [
      _vm.showCodeSearch
        ? _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.readonly, type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.aiRecognitionHandler(
                              true,
                              _vm.pm.aiRecognitionPostHandlerByCargoDoc
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(this.getItemTitle("AI Recognition")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { disabled: _vm.readonly, type: "primary" },
                        on: { click: _vm.linkOperationRequirement }
                      },
                      [
                        _vm._v(
                          _vm._s(this.getItemTitle("Operation Requirement"))
                        )
                      ]
                    ),
                    _c(
                      "el-dropdown",
                      {
                        staticStyle: { "padding-left": "5px" },
                        attrs: {
                          disabled: _vm.readonly,
                          "split-button": "",
                          type: "primary",
                          no: "1"
                        },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command1)
                          },
                          command: function(p) {
                            _vm.command1 = p
                            _vm.commandHandle(_vm.command1)
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(this.getItemTitle(_vm.command1)) + " "
                        ),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "Copy Last Time" } },
                              [
                                _vm._v(
                                  _vm._s(this.getItemTitle("Copy Last Time"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "Copy By File NO" } },
                              [
                                _vm._v(
                                  _vm._s(this.getItemTitle("Copy By File NO"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c(
          "div",
          {
            staticClass: "address-format-from",
            staticStyle: { display: "flex" }
          },
          [
            _c(
              "div",
              {
                staticClass: "section form-column",
                staticStyle: { width: "824px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.getItemTitle("HblInfo")))
                ]),
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      "margin-left": "18px",
                      "margin-right": "18px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "110px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            "config-module": "1001009",
                            "grid-options": _vm.ams2.gridOptions,
                            "column-defs": _vm.ams2ColumnDefs,
                            "row-data": _vm.ams2.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.ams2.gridApi = params.api
                            }
                          }
                        }),
                        _c("div", { staticStyle: { padding: "5px 0" } }, [
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    title: _vm.$t("SeaExport.addHbl"),
                                    no: "5"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.btnAddHblHandler()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("Add HB/L")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    title: _vm.$t(
                                      "SeaExport.SynchronizeHBLInformation"
                                    ),
                                    no: "2"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.btnSynchroClickHandlerByNewEns()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getItemTitle("Import HB/L"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "danger",
                                    title: _vm.$t("SeaExport.Delete"),
                                    no: "4"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onRemoveCargoDocAi()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticClass: "title",
                    staticStyle: { "margin-top": "46px" }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        "ENS " + _vm.$t("SeaExport.DeclarationInformation")
                      )
                    )
                  ]
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      "margin-left": "18px",
                      "margin-right": "18px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "110px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "blue-text",
                        attrs: { label: _vm.getEnsInfoAITitle("Filing Type") }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              disabled: _vm.readonly || _vm.isTradetech,
                              no: "declarationType"
                            },
                            model: {
                              value: _vm.form.declarationType,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "declarationType", $$v)
                              },
                              expression: "form.declarationType"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: {
                                label: _vm.isChineseLanguage
                                  ? "F14  |  有签发HBL，不含真实买卖方的HBL数据"
                                  : "F14  |  HBL data without seller & buyer Issue HBL",
                                value: "F14"
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.isChineseLanguage
                                  ? "F15  |  有签发HBL，包含真实收发通和买卖方的完整HBL数据"
                                  : "F15  |  Complete HBL data with all actors Issue HBL",
                                value: "F15"
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.isChineseLanguage
                                  ? "F16  |  有签发HBL，真实买卖方HBL补充数据"
                                  : "F16  |  HBL supplementary data of seller & buyer Issue HBL",
                                value: "F16"
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.isChineseLanguage
                                  ? "F17  |  不签发HBL，真实买卖方MBL补充数据"
                                  : "F17  |  MBL supplementary data of seller & buyer Direct BL",
                                value: "F17"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "blue-text",
                        attrs: { label: _vm.getEnsInfoAITitle("Carrier") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "carrierEori",
                            "static-options": _vm.shipCompanyInfos,
                            "filter-tag-names": [
                              "carrierEori",
                              "shipCompanyCode",
                              "shipCompanyEnglishName",
                              "shipCompanyChineseName"
                            ],
                            cache: false,
                            filterable: "",
                            "tag-value": "carrierEori",
                            "default-value": _vm.form.carrierEori,
                            "show-custom-label-in-option": true,
                            "custom-label": function(item) {
                              return _vm.customLabelHandler("Carrier", item)
                            }
                          },
                          on: { parentCallBack: _vm.carrierEoriChange }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "blue-text",
                        attrs: { label: _vm.getEnsInfoAITitle("Declarant") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "declarantEori",
                            "static-options": _vm.localData.officeEoriList,
                            cache: false,
                            filterable: "",
                            "tag-value": "eori",
                            "default-value": _vm.form.declarantEori,
                            "show-custom-label-in-option": true,
                            "custom-label": function(item) {
                              return _vm.customLabelHandler("Declarant", item)
                            }
                          },
                          on: { parentCallBack: _vm.declarantEoriChange }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "blue-text",
                        attrs: { label: _vm.getEnsInfoAITitle("Memberstate") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "8",
                            "static-options": _vm.declaringCountrys,
                            cache: false,
                            "default-value": _vm.form.declaringMemberCountry,
                            filterable: "",
                            clearable: "",
                            "filter-tag-names": ["code"],
                            "tag-name": "code",
                            "tag-value": "code",
                            "show-custom-label-in-option": true,
                            "custom-label": function(item) {
                              return _vm.customLabelHandler("Memberstate", item)
                            }
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.declaringMemberCountry = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "blue-text",
                        attrs: { label: _vm.getEnsInfoAITitle("Declare Type") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "chargesPaymentMethod",
                            "static-options":
                              _vm.SystemConstants.AMS_ENS_TRANSPORT_TYPES_AI,
                            cache: false,
                            "default-value": _vm.form.frob,
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "show-custom-label-in-option": true,
                            "custom-label": function(item) {
                              return _vm.customLabelHandler(
                                "Declare Type",
                                item
                              )
                            }
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.frob = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue-text",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.getEnsInfoAITitle("MB/L NO")))]
                        ),
                        _c("el-input", {
                          attrs: { disabled: _vm.readonly, no: "mbl" },
                          model: {
                            value: _vm.form.mbl,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mbl", $$v)
                            },
                            expression: "form.mbl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent(true, true, false),
                        attrs: {
                          label: _vm.getEnsInfoAITitle("Payment Method")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "chargesPaymentMethod",
                            "static-options":
                              _vm.SystemConstants.AMS_ENS_PAYMENT_METHODS,
                            cache: false,
                            "default-value": _vm.form.chargesPaymentMethod,
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "show-custom-label-in-option": true,
                            "custom-label": function(item) {
                              return _vm.customLabelHandler(
                                "Payment Method",
                                item
                              )
                            }
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.chargesPaymentMethod = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticClass: "title",
                    staticStyle: { "margin-top": "46px" },
                    attrs: {
                      title: "ENS " + _vm.$t("SeaExport.PortInformation")
                    }
                  },
                  [_vm._v(_vm._s(_vm.getItemTitle("Port Information")))]
                ),
                _c(
                  "el-form",
                  {
                    staticStyle: {
                      "margin-left": "18px",
                      "margin-right": "18px"
                    },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "110px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent(true, true, true),
                        attrs: {
                          label: _vm.getEnsInfoAITitle("Place of Loading")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "loadingPortCode",
                            filterable: "",
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            "default-value": _vm.form.loadingPortCode,
                            "tag-name": "englishName",
                            "show-custom-label-in-option": true,
                            "custom-label": function(item) {
                              return _vm.customLabelHandler(
                                "Place of Loading",
                                item
                              )
                            }
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "loadingPortCode",
                                "loadingPort"
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent(true, true, true),
                        attrs: {
                          label: _vm.getEnsInfoAITitle("Place of Discharge")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.dischargingPortCode || "",
                            "tag-name": "englishName",
                            no: "dischargingPortCode",
                            "show-custom-label-in-option": true,
                            "custom-label": function(item) {
                              return _vm.customLabelHandler(
                                "Place of Loading",
                                item
                              )
                            }
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "dischargingPortCode",
                                "dischargingPort"
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "section form-column",
                staticStyle: { width: "824px" }
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.getItemTitle("Related Information")))
                ]),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isF16F17,
                        expression: "!isF16F17"
                      }
                    ]
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: {
                          "margin-left": "18px",
                          "margin-right": "18px"
                        },
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": "110px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.getEnsInfoAITitle("Shipper")))]
                            ),
                            _c("cargo-company-select", {
                              staticStyle: {
                                display: "inline-block",
                                width: "359px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                no: "shipperCode",
                                "method-params": {
                                  shipper: true,
                                  active: true
                                },
                                "default-value":
                                  _vm.addressForm.shipperCode || "",
                                "allow-create": true,
                                placeholder: " "
                              },
                              on: {
                                change: function(val) {
                                  _vm.shipperChange(val)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-checkbox",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isF15,
                                    expression: "isF15"
                                  }
                                ],
                                model: {
                                  value: _vm.addressForm.copyToSeller,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addressForm,
                                      "copyToSeller",
                                      $$v
                                    )
                                  },
                                  expression: "addressForm.copyToSeller"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.CopyToSeller")))]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "vertical-align": "top",
                                  "margin-left": "27px"
                                },
                                attrs: {
                                  no: "shipperBtnAiRecognition",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.aiRecognitionHandler(
                                      false,
                                      _vm.aiRecognitionPostHandlerByShipper,
                                      _vm.SystemConstants
                                        .AMS_ENS_PROMPT_KEY_ADDRESS.code
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getItemTitle("Ai Recognition"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "vertical-align": "top",
                                  "margin-left": "27px !important"
                                },
                                attrs: {
                                  no: "shipperBtnCodeSearching",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.billAddressDialog.visible = true
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.getEnsInfoAITitle("name")))]
                            ),
                            _c("el-input", {
                              attrs: {
                                "filter-chars": false,
                                no: "shipperLine1"
                              },
                              model: {
                                value: _vm.addressForm.shipperLine1,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "shipperLine1", $$v)
                                },
                                expression: "addressForm.shipperLine1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getEnsInfoAITitle("Address1"))
                                )
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                "filter-chars": false,
                                no: "shipperLine3"
                              },
                              model: {
                                value: _vm.addressForm.shipperLine3,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "shipperLine3", $$v)
                                },
                                expression: "addressForm.shipperLine3"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _vm._v(
                                  _vm._s(_vm.getEnsInfoAITitle("Address2"))
                                )
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                "filter-chars": false,
                                no: "shipperLine4"
                              },
                              model: {
                                value: _vm.addressForm.shipperLine4,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "shipperLine4", $$v)
                                },
                                expression: "addressForm.shipperLine4"
                              }
                            })
                          ],
                          1
                        ),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticStyle: { color: "#1f75d5 !important" },
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.HouseNumber")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("No.")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      disabled: _vm.form.noHouseNumberByShipper,
                                      no: "shipperStreetNo"
                                    },
                                    model: {
                                      value: _vm.addressForm.shipperStreetNo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "shipperStreetNo",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.shipperStreetNo"
                                    }
                                  }),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-left": "25px" },
                                      on: {
                                        change: function(newVal) {
                                          _vm.updateStreetNoBynoHouseNumberHandler(
                                            newVal,
                                            "shipper"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.noHouseNumberByShipper,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "noHouseNumberByShipper",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.noHouseNumberByShipper"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.NoHouseNumber")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label blue-text",
                                      attrs: { title: _vm.$t("SeaExport.ZIP") }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("ZIP"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    class: _vm.zipMaxLength(
                                      _vm.addressForm.shipperPostalcode
                                    ),
                                    attrs: { no: "shipperPostalcode" },
                                    model: {
                                      value: _vm.addressForm.shipperPostalcode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "shipperPostalcode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "addressForm.shipperPostalcode"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticStyle: { color: "#1f75d5 !important" },
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.City")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("City")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    class: _vm.cityMaxLength(
                                      _vm.addressForm.shipperCity
                                    ),
                                    attrs: { no: "shipperCity" },
                                    model: {
                                      value: _vm.addressForm.shipperCity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "shipperCity",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.shipperCity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      staticStyle: {
                                        color: "#1f75d5 !important"
                                      },
                                      attrs: {
                                        title: _vm.$t("SeaExport.Country")
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("Country"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: " "
                                      },
                                      model: {
                                        value: _vm.addressForm.shipperCountry,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addressForm,
                                            "shipperCountry",
                                            $$v
                                          )
                                        },
                                        expression: "addressForm.shipperCountry"
                                      }
                                    },
                                    _vm._l(_vm.countryList, function(item) {
                                      return _c("el-option", {
                                        key: item.code,
                                        attrs: {
                                          label: _vm.customLabelHandler(
                                            "Country",
                                            item
                                          ),
                                          value: item.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.Tel")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("Tel")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    class: _vm.telMaxLength(
                                      _vm.addressForm.shipperTel
                                    ),
                                    attrs: { no: "shipperTel" },
                                    model: {
                                      value: _vm.addressForm.shipperTel,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "shipperTel",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.shipperTel"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      attrs: {
                                        title: _vm.$t("SeaExport.Email")
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("E-mail"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    class: _vm.emailMaxLength(
                                      _vm.addressForm.shipperEmail
                                    ),
                                    attrs: { no: "shipperEmail" },
                                    model: {
                                      value: _vm.addressForm.shipperEmail,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "shipperEmail",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.shipperEmail"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("Type")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        no: "shipperTypeOfPerson",
                                        placeholder: ""
                                      },
                                      model: {
                                        value:
                                          _vm.addressForm.shipperTypeOfPerson,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addressForm,
                                            "shipperTypeOfPerson",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addressForm.shipperTypeOfPerson"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Legal person | 法人"
                                            : "Legal person",
                                          value: "1"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Natural person  |  自然人"
                                            : "Natural person",
                                          value: "2"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Association of persons  |  协会团体"
                                            : "Association of persons",
                                          value: "3"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      attrs: { title: "EORI" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("EORI"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: { no: "shipperEori" },
                                    model: {
                                      value: _vm.addressForm.shipperEori,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "shipperEori",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.shipperEori"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c(
                          "el-form-item",
                          { staticStyle: { "margin-top": "20px" } },
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getEnsInfoAITitle("Consignee"))
                                )
                              ]
                            ),
                            _c("cargo-company-select", {
                              staticStyle: {
                                display: "inline-block",
                                width: "359px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                no: "shipperCode",
                                "method-params": {
                                  shipper: true,
                                  active: true
                                },
                                "default-value":
                                  _vm.addressForm.consigneeCode || "",
                                "allow-create": true,
                                placeholder: " "
                              },
                              on: {
                                change: function(val) {
                                  _vm.consigneeChange(val)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-checkbox",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isF15,
                                    expression: "isF15"
                                  }
                                ],
                                model: {
                                  value: _vm.addressForm.copyToBuyer,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.addressForm,
                                      "copyToBuyer",
                                      $$v
                                    )
                                  },
                                  expression: "addressForm.copyToBuyer"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.CopyToBuyer")))]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "vertical-align": "top",
                                  "margin-left": "27px"
                                },
                                attrs: {
                                  no: "consigneeBtnAiRecognition",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.aiRecognitionHandler(
                                      false,
                                      _vm.aiRecognitionPostHandlerByConsignee,
                                      _vm.SystemConstants
                                        .AMS_ENS_PROMPT_KEY_ADDRESS.code
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getItemTitle("Ai Recognition"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "vertical-align": "top",
                                  "margin-left": "27px !important"
                                },
                                attrs: {
                                  no: "shipperBtnCodeSearching",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.billAddressDialog.visible = true
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { title: _vm.$t("SeaExport.CompanyTitle") }
                          },
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.getEnsInfoAITitle("name")))]
                            ),
                            _c("el-input", {
                              attrs: {
                                "filter-chars": false,
                                no: "consigneeLine1"
                              },
                              model: {
                                value: _vm.addressForm.consigneeLine1,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "consigneeLine1",
                                    $$v
                                  )
                                },
                                expression: "addressForm.consigneeLine1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getEnsInfoAITitle("Address1"))
                                )
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                "filter-chars": false,
                                no: "consigneeLine3"
                              },
                              model: {
                                value: _vm.addressForm.consigneeLine3,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "consigneeLine3",
                                    $$v
                                  )
                                },
                                expression: "addressForm.consigneeLine3"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { title: _vm.$t("SeaExport.Addr") + "2" } },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _vm._v(
                                  _vm._s(_vm.getEnsInfoAITitle("Address2"))
                                )
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                "filter-chars": false,
                                no: "consigneeLine4"
                              },
                              model: {
                                value: _vm.addressForm.consigneeLine4,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "consigneeLine4",
                                    $$v
                                  )
                                },
                                expression: "addressForm.consigneeLine4"
                              }
                            })
                          ],
                          1
                        ),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticStyle: { color: "#1f75d5 !important" },
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.HouseNumber")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("No.")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      disabled:
                                        _vm.form.noHouseNumberByConsignee,
                                      no: "consigneeStreetNo"
                                    },
                                    model: {
                                      value: _vm.addressForm.consigneeStreetNo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "consigneeStreetNo",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "addressForm.consigneeStreetNo"
                                    }
                                  }),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-left": "25px" },
                                      on: {
                                        change: function(newVal) {
                                          _vm.updateStreetNoBynoHouseNumberHandler(
                                            newVal,
                                            "consignee"
                                          )
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.form.noHouseNumberByConsignee,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "noHouseNumberByConsignee",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.noHouseNumberByConsignee"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.NoHouseNumber")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label blue-text",
                                      attrs: { title: _vm.$t("SeaExport.ZIP") }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("ZIP"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    class: _vm.zipMaxLength(
                                      _vm.addressForm.consigneePostalcode
                                    ),
                                    attrs: { no: "consigneePostalcode" },
                                    model: {
                                      value:
                                        _vm.addressForm.consigneePostalcode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "consigneePostalcode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "addressForm.consigneePostalcode"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticStyle: { color: "#1f75d5 !important" },
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.City")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("City")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    class: _vm.cityMaxLength(
                                      _vm.addressForm.consigneeCity
                                    ),
                                    attrs: { no: "consigneeCity" },
                                    model: {
                                      value: _vm.addressForm.consigneeCity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "consigneeCity",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.consigneeCity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      staticStyle: {
                                        color: "#1f75d5 !important"
                                      },
                                      attrs: {
                                        title: _vm.$t("SeaExport.Country")
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("Country"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: " "
                                      },
                                      model: {
                                        value: _vm.addressForm.consigneeCountry,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addressForm,
                                            "consigneeCountry",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addressForm.consigneeCountry"
                                      }
                                    },
                                    _vm._l(_vm.countryList, function(item) {
                                      return _c("el-option", {
                                        key: item.code,
                                        attrs: {
                                          label: _vm.customLabelHandler(
                                            "Country",
                                            item
                                          ),
                                          value: item.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.Tel")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("Tel")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    class: _vm.telMaxLength(
                                      _vm.addressForm.consigneeTel
                                    ),
                                    attrs: { no: "consigneeTel" },
                                    model: {
                                      value: _vm.addressForm.consigneeTel,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "consigneeTel",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.consigneeTel"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      attrs: {
                                        title: _vm.$t("SeaExport.Email")
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("E-mail"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    class: _vm.emailMaxLength(
                                      _vm.addressForm.consigneeEmail
                                    ),
                                    attrs: { no: "consigneeEmail" },
                                    model: {
                                      value: _vm.addressForm.consigneeEmail,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "consigneeEmail",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.consigneeEmail"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("Type")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        no: "consigneeTypeOfPerson",
                                        placeholder: ""
                                      },
                                      model: {
                                        value:
                                          _vm.addressForm.consigneeTypeOfPerson,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addressForm,
                                            "consigneeTypeOfPerson",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addressForm.consigneeTypeOfPerson"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Legal person | 法人"
                                            : "Legal person",
                                          value: "1"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Natural person  |  自然人"
                                            : "Natural person",
                                          value: "2"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Association of persons  |  协会团体"
                                            : "Association of persons",
                                          value: "3"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      attrs: { title: "EORI" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getItemTitle("ADDRESS EORI"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: { no: "consigneeEori" },
                                    model: {
                                      value: _vm.addressForm.consigneeEori,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "consigneeEori",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.consigneeEori"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isF15,
                        expression: "isF15"
                      }
                    ],
                    staticStyle: {
                      display: "flex",
                      "justify-content": "right",
                      color: "#1f75d5 !important",
                      "margin-top": "10px",
                      "margin-right": "15px",
                      cursor: "pointer"
                    },
                    on: {
                      click: function($event) {
                        return _vm.expandSellerBuyer()
                      }
                    }
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("SeaExport.ExpandSellerBuyer")))
                    ]),
                    _c("img", {
                      style: _vm.showSellerBuyer
                        ? "transform: rotate(180deg)"
                        : "",
                      attrs: {
                        src: require("@/assets/icons/address-expand.png"),
                        alt: ""
                      }
                    })
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.isF15 && _vm.showSellerBuyer) || _vm.isF16F17,
                        expression: "(isF15 && showSellerBuyer) || isF16F17"
                      }
                    ]
                  },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: {
                          "margin-left": "18px",
                          "margin-right": "18px"
                        },
                        attrs: {
                          disabled: _vm.readonly,
                          "label-width": "110px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.getEnsInfoAITitle("Seller")))]
                            ),
                            _c("cargo-company-select", {
                              staticStyle: {
                                display: "inline-block",
                                width: "359px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                no: "shipperCode",
                                "method-params": {
                                  shipper: true,
                                  active: true
                                },
                                "default-value":
                                  _vm.addressForm.shipperCode || "",
                                "allow-create": true,
                                placeholder: " "
                              },
                              on: {
                                change: function(val) {
                                  _vm.sellerChange(val)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "vertical-align": "top",
                                  "margin-left": "27px"
                                },
                                attrs: {
                                  no: "sellerBtnAiRecognition",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.aiRecognitionHandler(
                                      false,
                                      _vm.aiRecognitionPostHandlerBySeller,
                                      _vm.SystemConstants
                                        .AMS_ENS_PROMPT_KEY_ADDRESS.code
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getItemTitle("Ai Recognition"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isF16F17,
                                    expression: "!isF16F17"
                                  }
                                ],
                                staticStyle: {
                                  "vertical-align": "top",
                                  "margin-left": "27px !important"
                                },
                                attrs: {
                                  no: "shipperBtnCodeSearching",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.billAddressDialog.visible = true
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.getEnsInfoAITitle("name")))]
                            ),
                            _c("el-input", {
                              attrs: {
                                "filter-chars": false,
                                no: "sellerName"
                              },
                              model: {
                                value: _vm.addressForm.sellerName,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "sellerName", $$v)
                                },
                                expression: "addressForm.sellerName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getEnsInfoAITitle("Address1"))
                                )
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                "filter-chars": false,
                                no: "sellerAddress1"
                              },
                              model: {
                                value: _vm.addressForm.sellerAddress1,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "sellerAddress1",
                                    $$v
                                  )
                                },
                                expression: "addressForm.sellerAddress1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _vm._v(
                                  _vm._s(_vm.getEnsInfoAITitle("Address2"))
                                )
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                "filter-chars": false,
                                no: "sellerAddress2"
                              },
                              model: {
                                value: _vm.addressForm.sellerAddress2,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "sellerAddress2",
                                    $$v
                                  )
                                },
                                expression: "addressForm.sellerAddress2"
                              }
                            })
                          ],
                          1
                        ),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticStyle: { color: "#1f75d5 !important" },
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.HouseNumber")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("No.")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      disabled: _vm.form.noHouseNumberBySeller,
                                      no: "sellerStreetNo"
                                    },
                                    model: {
                                      value: _vm.addressForm.sellerStreetNo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "sellerStreetNo",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.sellerStreetNo"
                                    }
                                  }),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-left": "25px" },
                                      on: {
                                        change: function(newVal) {
                                          _vm.updateStreetNoBynoHouseNumberHandler(
                                            newVal,
                                            "seller"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.noHouseNumberBySeller,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "noHouseNumberBySeller",
                                            $$v
                                          )
                                        },
                                        expression: "form.noHouseNumberBySeller"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.NoHouseNumber")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label blue-text",
                                      attrs: { title: _vm.$t("SeaExport.ZIP") }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("ZIP"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    class: _vm.zipMaxLength(
                                      _vm.addressForm.sellerPostalcode
                                    ),
                                    attrs: { no: "sellerPostalcode" },
                                    model: {
                                      value: _vm.addressForm.sellerPostalcode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "sellerPostalcode",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.sellerPostalcode"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticStyle: { color: "#1f75d5 !important" },
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.City")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("City")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    class: _vm.cityMaxLength(
                                      _vm.addressForm.sellerCity
                                    ),
                                    attrs: { no: "sellerCity" },
                                    model: {
                                      value: _vm.addressForm.sellerCity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "sellerCity",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.sellerCity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      staticStyle: {
                                        color: "#1f75d5 !important"
                                      },
                                      attrs: {
                                        title: _vm.$t("SeaExport.Country")
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("Country"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: " "
                                      },
                                      model: {
                                        value: _vm.addressForm.sellerCountry,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addressForm,
                                            "sellerCountry",
                                            $$v
                                          )
                                        },
                                        expression: "addressForm.sellerCountry"
                                      }
                                    },
                                    _vm._l(_vm.countryList, function(item) {
                                      return _c("el-option", {
                                        key: item.code,
                                        attrs: {
                                          label: _vm.customLabelHandler(
                                            "Country",
                                            item
                                          ),
                                          value: item.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.Tel")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("Tel")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    class: _vm.telMaxLength(
                                      _vm.addressForm.sellerTel
                                    ),
                                    attrs: { no: "sellerTel" },
                                    model: {
                                      value: _vm.addressForm.sellerTel,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "sellerTel",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.sellerTel"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      attrs: {
                                        title: _vm.$t("SeaExport.Email")
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("E-mail"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    class: _vm.emailMaxLength(
                                      _vm.addressForm.sellerEmail
                                    ),
                                    attrs: { no: "sellerEmail" },
                                    model: {
                                      value: _vm.addressForm.sellerEmail,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "sellerEmail",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.sellerEmail"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("Type")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        no: "sellerTypeOfPerson",
                                        placeholder: ""
                                      },
                                      model: {
                                        value:
                                          _vm.addressForm.sellerTypeOfPerson,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addressForm,
                                            "sellerTypeOfPerson",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addressForm.sellerTypeOfPerson"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Legal person | 法人"
                                            : "Legal person",
                                          value: "1"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Natural person  |  自然人"
                                            : "Natural person",
                                          value: "2"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Association of persons  |  协会团体"
                                            : "Association of persons",
                                          value: "3"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      attrs: { title: "EORI" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getItemTitle("ADDRESS EORI"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: { no: "sellerEori" },
                                    model: {
                                      value: _vm.addressForm.sellerEori,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "sellerEori",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.sellerEori"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c(
                          "el-form-item",
                          { staticStyle: { "margin-top": "20px" } },
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.getEnsInfoAITitle("Buyer")))]
                            ),
                            _c("cargo-company-select", {
                              staticStyle: {
                                display: "inline-block",
                                width: "359px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                no: "shipperCode",
                                "method-params": {
                                  shipper: true,
                                  active: true
                                },
                                "default-value":
                                  _vm.addressForm.shipperCode || "",
                                "allow-create": true,
                                placeholder: " "
                              },
                              on: {
                                change: function(val) {
                                  _vm.buyerChange(val)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  "vertical-align": "top",
                                  "margin-left": "27px"
                                },
                                attrs: {
                                  no: "buyerBtnAiRecognition",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.aiRecognitionHandler(
                                      false,
                                      _vm.aiRecognitionPostHandlerByBuyer,
                                      _vm.SystemConstants
                                        .AMS_ENS_PROMPT_KEY_ADDRESS.code
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getItemTitle("Ai Recognition"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isF16F17,
                                    expression: "!isF16F17"
                                  }
                                ],
                                staticStyle: {
                                  "vertical-align": "top",
                                  "margin-left": "27px !important"
                                },
                                attrs: {
                                  no: "shipperBtnCodeSearching",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.billAddressDialog.visible = true
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.CodeSearching"))
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: { title: _vm.$t("SeaExport.CompanyTitle") }
                          },
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [_vm._v(_vm._s(_vm.getEnsInfoAITitle("name")))]
                            ),
                            _c("el-input", {
                              attrs: { "filter-chars": false, no: "buyerName" },
                              model: {
                                value: _vm.addressForm.buyerName,
                                callback: function($$v) {
                                  _vm.$set(_vm.addressForm, "buyerName", $$v)
                                },
                                expression: "addressForm.buyerName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              {
                                class: _vm.isDifferent(true, true, true, true),
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.getEnsInfoAITitle("Address1"))
                                )
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                "filter-chars": false,
                                no: "buyerAddress1"
                              },
                              model: {
                                value: _vm.addressForm.buyerAddress1,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "buyerAddress1",
                                    $$v
                                  )
                                },
                                expression: "addressForm.buyerAddress1"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _vm._v(
                                  _vm._s(_vm.getEnsInfoAITitle("Address2"))
                                )
                              ]
                            ),
                            _c("el-input", {
                              attrs: {
                                "filter-chars": false,
                                no: "buyerAddress2"
                              },
                              model: {
                                value: _vm.addressForm.buyerAddress2,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.addressForm,
                                    "buyerAddress2",
                                    $$v
                                  )
                                },
                                expression: "addressForm.buyerAddress2"
                              }
                            })
                          ],
                          1
                        ),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticStyle: { color: "#1f75d5 !important" },
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.HouseNumber")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("No.")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: _vm.form.noHouseNumberByBuyer,
                                      no: "buyerStreetNo"
                                    },
                                    model: {
                                      value: _vm.addressForm.buyerStreetNo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "buyerStreetNo",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.buyerStreetNo"
                                    }
                                  }),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-left": "25px" },
                                      on: {
                                        change: function(newVal) {
                                          _vm.updateStreetNoBynoHouseNumberHandler(
                                            newVal,
                                            "buyer"
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.noHouseNumberByBuyer,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "noHouseNumberByBuyer",
                                            $$v
                                          )
                                        },
                                        expression: "form.noHouseNumberByBuyer"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.NoHouseNumber")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label blue-text",
                                      attrs: { title: _vm.$t("SeaExport.ZIP") }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("ZIP"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    class: _vm.zipMaxLength(
                                      _vm.addressForm.buyerPostalcode
                                    ),
                                    attrs: { no: "buyerPostalcode" },
                                    model: {
                                      value: _vm.addressForm.buyerPostalcode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "buyerPostalcode",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.buyerPostalcode"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              staticStyle: { color: "#1f75d5 !important" },
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.City")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("City")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    class: _vm.cityMaxLength(
                                      _vm.addressForm.buyerCity
                                    ),
                                    attrs: { no: "buyerCity" },
                                    model: {
                                      value: _vm.addressForm.buyerCity,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "buyerCity",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.buyerCity"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      staticStyle: {
                                        color: "#1f75d5 !important"
                                      },
                                      attrs: {
                                        title: _vm.$t("SeaExport.Country")
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("Country"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        clearable: "",
                                        placeholder: " "
                                      },
                                      model: {
                                        value: _vm.addressForm.buyerCountry,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addressForm,
                                            "buyerCountry",
                                            $$v
                                          )
                                        },
                                        expression: "addressForm.buyerCountry"
                                      }
                                    },
                                    _vm._l(_vm.countryList, function(item) {
                                      return _c("el-option", {
                                        key: item.code,
                                        attrs: {
                                          label: _vm.customLabelHandler(
                                            "Country",
                                            item
                                          ),
                                          value: item.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            {
                              attrs: {
                                slot: "label",
                                title: _vm.$t("SeaExport.Tel")
                              },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("Tel")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    class: _vm.telMaxLength(
                                      _vm.addressForm.buyerTel
                                    ),
                                    attrs: { no: "buyerTel" },
                                    model: {
                                      value: _vm.addressForm.buyerTel,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "buyerTel",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.buyerTel"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      attrs: {
                                        title: _vm.$t("SeaExport.Email")
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getEnsInfoAITitle("E-mail"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    class: _vm.emailMaxLength(
                                      _vm.addressForm.buyerEmail
                                    ),
                                    attrs: { no: "buyerEmail" },
                                    model: {
                                      value: _vm.addressForm.buyerEmail,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "buyerEmail",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.buyerEmail"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]),
                        _c("el-form-item", [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v(_vm._s(_vm.getEnsInfoAITitle("Type")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "35%"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        no: "buyerTypeOfPerson",
                                        placeholder: ""
                                      },
                                      model: {
                                        value:
                                          _vm.addressForm.buyerTypeOfPerson,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addressForm,
                                            "buyerTypeOfPerson",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addressForm.buyerTypeOfPerson"
                                      }
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Legal person | 法人"
                                            : "Legal person",
                                          value: "1"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Natural person  |  自然人"
                                            : "Natural person",
                                          value: "2"
                                        }
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.isChineseLanguage
                                            ? "Association of persons  |  协会团体"
                                            : "Association of persons",
                                          value: "3"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    width: "50%"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "center-label",
                                      attrs: { title: "EORI" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getItemTitle("ADDRESS EORI"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    attrs: { no: "buyerEori" },
                                    model: {
                                      value: _vm.addressForm.buyerEori,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addressForm,
                                          "buyerEori",
                                          $$v
                                        )
                                      },
                                      expression: "addressForm.buyerEori"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { "margin-bottom": "10px" } })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isF14,
                        expression: "isF14"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "margin-top": "46px",
                          "justify-content": "left",
                          "align-items": "center",
                          gap: "10px"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "title",
                            attrs: {
                              title: _vm.$t("SeaExport.SubstratumDeclarant")
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getItemTitle("Substratum Declarant"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: {
                              disabled: _vm.readonly,
                              size: "mini",
                              type: "primary"
                            },
                            on: { click: _vm.addRouteCountry2 }
                          },
                          [_vm._v(_vm._s(_vm.$t("Partners.btnAdd")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: {
                              disabled: _vm.readonly,
                              size: "mini",
                              type: "danger"
                            },
                            on: { click: _vm.deleteRouteCountry2 }
                          },
                          [_vm._v(_vm._s(_vm.$t("Partners.btnRemove")))]
                        )
                      ],
                      1
                    ),
                    _c("cargo-ag-grid", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "config-module": "131703",
                        "grid-options":
                          _vm.coloadInSelfFilingIndicator.gridOptions,
                        "column-defs": _vm.columnDefs2,
                        "row-data": _vm.form.ensDeclarationData
                      },
                      on: {
                        gridReady: function(params) {
                          _vm.gridApi2 = params.api
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isF16F17,
                expression: "!isF16F17"
              }
            ],
            staticClass: "section"
          },
          [
            _c(
              "span",
              {
                staticClass: "title",
                attrs: { title: _vm.$t("SeaExport.ContainerInformation") }
              },
              [_vm._v(_vm._s(_vm.getItemTitle("House Container Information")))]
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit,
                        expression: "isEdit"
                      }
                    ],
                    staticStyle: { padding: "5px 0" }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.AddContainerInformation"),
                          no: "71"
                        },
                        on: {
                          click: function($event) {
                            _vm.cargoDocUsageSelectedDialog.visible = true
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Import Container No")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.AddContainerInformation"),
                          no: "89"
                        },
                        on: { click: _vm.addContainerUsageClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Add Container No")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          title: _vm.$t("SeaExport.RemoveContainerInformation"),
                          no: "72"
                        },
                        on: { click: _vm.removeContainerUsageClickHandler }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.AiRecognition"),
                          no: "90"
                        },
                        on: {
                          click: function($event) {
                            return _vm.aiRecognitionHandler(
                              false,
                              _vm.aiRecognitionPostHandlerByCargo,
                              _vm.SystemConstants.AMS_ENS_PROMPT_KEY_CARGO.code
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Ai Recognition")))]
                    )
                  ],
                  1
                ),
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", height: "350px" },
                  attrs: {
                    "config-module": "131704",
                    "grid-options": _vm.container.gridOptions,
                    "column-defs": _vm.containerColumnDefs,
                    "row-data": _vm.containerFinalRowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.container.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isF16F17,
                expression: "!isF16F17"
              }
            ],
            staticClass: "section"
          },
          [
            _c(
              "span",
              {
                staticClass: "title",
                attrs: { title: _vm.$t("SeaExport.CargoInfo") }
              },
              [_vm._v(_vm._s(_vm.getItemTitle("Cargo Information")))]
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c(
                  "div",
                  { staticStyle: { padding: "5px 0" } },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isEdit,
                            expression: "isEdit"
                          }
                        ],
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.AddContainerInformation"),
                          no: "69"
                        },
                        on: { click: _vm.addCargoInfo }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Add Description")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isEdit,
                            expression: "isEdit"
                          }
                        ],
                        attrs: {
                          type: "danger",
                          title: _vm.$t("SeaExport.RemoveContainerInformation"),
                          no: "70"
                        },
                        on: { click: _vm.deleteCargoInfo }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isEdit,
                            expression: "isEdit"
                          }
                        ],
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.AiRecognition"),
                          no: "91"
                        },
                        on: {
                          click: function($event) {
                            return _vm.aiRecognitionHandler(
                              false,
                              _vm.aiRecognitionPostHandlerByCargo,
                              _vm.SystemConstants.AMS_ENS_PROMPT_KEY_CARGO.code
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Ai Recognition")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isEdit,
                            expression: "isEdit"
                          }
                        ],
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.Query") + " HS Code",
                          no: "92"
                        },
                        on: {
                          click: function($event) {
                            return _vm.navigateToLink("Query HS Code")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Query HS Code")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isEdit,
                            expression: "isEdit"
                          }
                        ],
                        attrs: {
                          type: "primary",
                          title: _vm.$t("SeaExport.Query") + " CUS No",
                          no: "93"
                        },
                        on: {
                          click: function($event) {
                            return _vm.navigateToLink("Query CUS No")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Query CUS No")))]
                    ),
                    _c("span", { staticStyle: { float: "right" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("CargoMsg.Cargo_AmountToP")) + " "
                      ),
                      _c("span", { staticStyle: { color: "#1D6ACF" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.calculatedTotals.quantity) + " "
                        )
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("SeaExport.itemCount")) + " "),
                      _c("span", { staticStyle: { color: "#1D6ACF" } }, [
                        _vm._v(" " + _vm._s(_vm.calculatedTotals.weight) + " ")
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("SeaExport.kilogram")) + " ")
                    ])
                  ],
                  1
                ),
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%", height: "350px" },
                  attrs: {
                    "config-module": "131705",
                    "grid-options": _vm.cargoInfomation.gridOptions,
                    "column-defs": _vm.cargoInformationColumnDefs,
                    "row-data": _vm.form.ensCargoInfo
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi3 = params.api
                    }
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "warning-count": _vm.advanceTextDialog.warningCount,
              disabled: _vm.readonly,
              no: "73"
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary", no: "74" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "75" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.receiptInfoDialog.visible,
            title: _vm.receiptInfoDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.receiptInfoDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.receiptInfoDialog.gridOptions,
              "column-defs": _vm.receiptInfoDialog.columnDefs,
              "row-data": _vm.receiptInfoDialog.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.receiptInfoDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c("cargo-doc-usage-selected-dialog", {
        attrs: {
          visible: _vm.cargoDocUsageSelectedDialog.visible,
          job: _vm.job,
          "doc-type": _vm.CargoDocConsts.AMS
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cargoDocUsageSelectedDialog, "visible", $event)
          },
          callback: _vm.cargoDocUsageSelectedDialog.callback
        }
      }),
      _c("ams-log-view-title-dialog", {
        attrs: {
          visible: _vm.amsLogViewTitleDialog.visible,
          "row-data": _vm.amsLogViewTitleDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.amsLogViewTitleDialog, "visible", $event)
          }
        }
      }),
      _c("afr-address-dialog", {
        attrs: {
          visible: _vm.searchBillNoDialog.visible,
          params: _vm.searchBillNoDialog.params,
          "no-label": _vm.amsTitle,
          "no-title": _vm.amsTitleCn
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
          },
          selected: function(p) {
            _vm.pm.selectionItemHandler(p)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.checkDialog.visible,
            title: _vm.checkDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.checkDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.checkDialog.gridOptions,
              "column-defs": _vm.checkDialog.columnDefs,
              "row-data": _vm.checkDialog.rowData,
              "show-side-bar": false
            },
            on: {
              gridReady: function(params) {
                _vm.checkDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c("bill-address-dialog", {
        attrs: { visible: _vm.billAddressDialog.visible, job: _vm.job },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c("cargo-ai-recognition-dialog", {
        attrs: {
          visible: _vm.aiRecognitionDialog.visible,
          multimodal: _vm.aiRecognitionDialog.multimodal,
          "job-uuid": _vm.aiRecognitionDialog.jobUuid,
          "doc-uuid": _vm.aiRecognitionDialog.docUuid,
          "hbl-nbr2": _vm.aiRecognitionDialog.hblNbr2,
          source: _vm.aiRecognitionDialog.source,
          "prompt-key": _vm.aiRecognitionDialog.promptKey,
          "page-source": "customsInfo",
          "i-channel": _vm.aiRecognitionDialog.iChannel,
          "call-back": _vm.aiRecognitionDialog.callBack
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.aiRecognitionDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }